import cn from "classnames";

let helper = {};

export const withFullStoryExclude = function (...classnames) {
    if (classnames.length === 0) {
        return "fs-exclude";
    } else {
        return cn("fs-exclude", classnames.join(" "));
    }
};

export const withFullStoryMask = function (...classnames) {
    if (classnames.length === 0) {
        return "fs-mask";
    } else {
        return cn("fs-mask", classnames.join(" "));
    }
};

helper.withFullStoryExclude = withFullStoryExclude;
helper.withFullStoryMask = withFullStoryMask;
export default helper;
